var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"scroll-box"},_vm._l((_vm.pages),function(item,index){return _c('div',{key:index + item,ref:'page-' + index,refInFor:true,staticClass:"page-item"},[_vm._t("default",null,{"page":index + 1})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }